'use client';
import { useState } from 'react';
import { useRouter } from 'next/navigation';
import { Alert, Button, Stack, Text, Title } from '@mantine/core';
import { enableCreatorRole } from '@/lib/actions/business-workspaces';
/** `next` must already be a validated local path (see resolveSafeNextPath). */
export function CreatorAccessButton({ next }: { next?: string | null }) {
  const router = useRouter();
  const [pending, setPending] = useState(false);
  const [error, setError] = useState('');
  return (
    <Stack className="mx-auto max-w-md px-4 py-16" gap="lg">
      <Title order={1}>Create your media kit</Title>
      <Text c="dimmed">
        Add a creator profile to your existing account. Your brand conversations stay in your brand
        inbox.
      </Text>
      {error && <Alert color="red">{error}</Alert>}
      <Button
        loading={pending}
        onClick={async () => {
          setPending(true);
          setError('');
          try {
            const result = await enableCreatorRole();
            if (result.ok) {
              router.push(next ?? '/dashboard');
              router.refresh();
            } else setError(result.error);
          } catch {
            setError('Creator access could not be added. Please try again.');
          } finally {
            setPending(false);
          }
        }}
      >
        Continue as a creator
      </Button>
      <Button component="a" href="/brands/dashboard" variant="subtle">
        Back to your brand inbox
      </Button>
    </Stack>
  );
}
